<template>
    <div class="container-fluid">
        <nav-header :navItems="[
            {
                name: 'Edit',
                link: {
                    name: 'Job Stack Deployment Pipeline Edit',
                    params: { sandboxId: `${selectedSandbox}`, id: `${$route.params.id}` },
                },
            },
            {
                name: 'Pipeline',
                link: {
                    name: 'Job Stack Deployment Details Pipeline',
                    params: { sandboxId: `${selectedSandbox}`, id: `${$route.params.id}` },
                },
            },
        ]" pretitle="aqfer Graph Manager" :breadcrumbTitle=true @nav-close-clicked="closeNav">
            <template v-slot:breadcrumb-title>
                <nav aria-label="breadcrumb" class="header-title">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a @click="closeClick" href="#" class="h1">Deployments</a></li>
                        <li class="breadcrumb-item active h1" aria-current="page">{{ $route.params.id }}</li>
                    </ol>
                </nav>
            </template>
            <template v-slot:header-button-content>
                <div class="custom-btn-group">
                    <button v-if="showRunAllButton && jobDetails?.length > 0" class="btn btn-primary"
                        @click.prevent="onRunAllClick" :disabled="running">
                        <div v-if="running">
                            <div class="spinner-border spinner-border-sm" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            <span v-if="pipelineExecutionDetails?.status == 'RUNNING'" class="ms-1">
                                Running
                            </span>
                        </div>
                        <div v-else>
                            <slot></slot>Run All
                            <span class="ms-1">
                                <i class="fa fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Run all jobs in this deployment"></i>
                            </span>
                        </div>
                    </button>
                    <div v-if="editMode">
                        <button v-if="showEditButton" class="btn btn-success" @click.prevent="onSaveclick" :disabled="saving">
                            <div v-if="saving" class="spinner-border spinner-border-sm me-1" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Save
                        </button>
                        <button v-if="showEditButton" class="btn btn-success" @click.prevent="onSaveAndRunCLick" :disabled="saving">
                            <div v-if="saving" class="spinner-border spinner-border-sm me-1" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Save & Run
                            <span v-if="saveAndRunStatus?.save_and_run_tooltip" class="ms-1">
                                <i class="fa fa-circle-exclamation text-warning" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="saveAndRunStatus.save_and_run_tooltip"></i>
                            </span>
                        </button>
                        <button v-if="showEditButton" class="btn btn-secondary" @click.prevent="onCancelClick" :disabled="saving">
                            <div>
                                <slot></slot>Cancel
                            </div>
                        </button>
                    </div>
                    <div v-else>
                        <button v-if="showEditButton" class="btn btn-info" @click.prevent="onEditClick">
                            <div>
                                <slot></slot>Edit
                            </div>
                        </button>
                    </div>
                    <button v-if="showPromoteButton && !editMode" class="btn btn-primary flex" @click.prevent="onPromoteClick" :disabled="promoting || !jobDetails || jobDetails.length === 0 || (promotionStatus && promotionStatus.promotion_enabled === false)">
                        <div v-if="promoting == 'promoting'" class="spinner-border spinner-border-sm me-1" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Promote
                        <span v-if="promotionStatus?.promotion_tooltip" class="ms-1">
                            <i :class="promotionStatus.promotion_tooltip_icon_class || 'fa fa-circle-exclamation text-warning'" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="promotionStatus.promotion_tooltip"></i>
                        </span>
                    </button>
                    <button @click="closeClick" class="btn btn-secondary lift">
                        <i class="fa fa-arrow-left me-1"></i> Back to Deployments list
                    </button>
                </div>
            </template>
        </nav-header>
        <div>
            <router-view :deployment="deployment" :jobNames="jobNames" :editMode="editMode" :loading="loading"
                :jobs="jobDetails" :saveTrigger="saveTrigger" :pipelineExecutionDetails="pipelineExecutionDetails"
                :saveAndRunTrigger="saveAndRunTrigger" :promoteJobsTrigger="promoteJobsTrigger" v-on:refreshJobsDetails="fetchJobDetails"
                :getPromotionStatusTrigger="getPromotionStatusTrigger" v-on:setRunAllButton="setRunAllButton" v-on:setEditButton="setEditButton" v-on:setEditMode="setEditMode"
                v-on:saving="showSaving" v-on:promoting="showPromoting" v-on:setPromoteButton="setPromoteButton" v-on:getPromotionStatus="getPromotionStatus"
                v-on:getSaveAndRunStatus="getSaveAndRunStatus" v-on:triggerPipelineStatusCheck="triggerPipelineStatusCheck">
            </router-view>
        </div>
    </div>
</template>

<script>
import NavHeader from "../../components/NavHeader.vue";
import { mapActions } from "vuex";
import { DateTimeFormat } from '../../utils/commonFunction';
import axios from 'axios';
export default {
    name: "Job Stack Deployment Details",
    components: { NavHeader },
    data() {
        return {
            selectedSandbox: this.$route.params.sandboxId,

            loading: false,
            saving: false,
            running: false,
            promoting: '',
            editMode: false,
            saveTrigger: false,
            saveAndRunTrigger: false,
            saveAndRunStatus: null,
            promoteJobsTrigger: false,
            getPromotionStatusTrigger: false, // to inspect promotion status
            promotionStatus: null,

            deployment: null,
            jobDetails: [], // Store the job details here
            pipelineExecutionDetails: {}, // Store the pipeline execution details here

            showRunAllButton: false,
            showEditButton: false,
            showPromoteButton: false,
            breakCheck: false,
        };
    },
    async beforeMount() {
        await this.fetchDeployment();
        await this.fetchJobDetails();
        const executionId = await this.getLatestExecutionId();
        await this.trackPipelineExecutionStatus(executionId);
    },
    beforeUnmount() {
        this.breakCheck = true;
    },
    computed: {
        jobNames() {
            if (this.deployment?.jobs) {
                try {
                    return this.deployment.jobs.map(job => job.name);
                } catch (e) {
                    return [];
                }
            }
            return []
        },
        pipelineJob() {
            return this.jobDetails?.find(job => job.jobDetails?.kind.toLowerCase() === 'pipeline');
        },
    },
    methods: {
        ...mapActions({
            readDeployment: "amdp/readJobStackDeployment",
        }),
        DateTimeFormat,
        async fetchDeployment() {
            this.loading = true;
            try {
                const response = await this.readDeployment({
                    sandboxName: this.$route.params.sandboxId,
                    deploymentId: this.$route.params.id
                });
                this.deployment = response.data;
            } catch (error) {
                console.error("Error fetching job stack deployments: ", error);
                let err = error.response?.data?.error ? error.response.data.error : error.message;
                this.$store.dispatch("addToast", {
                    message: err || "Something went wrong when fetching job stack deployment. Please contact support.",
                    type: "error",
                });
            } finally {
                this.loading = false;
            }
        },
        async fetchJobDetails() {
            if (!this.jobNames || this.jobNames.length === 0) {
                console.log('No jobs found in the deployment');
                this.jobDetails = [];
                return;
            }

            this.loading = true;
            try {
                const details = await Promise.all(
                    this.jobNames.map(async (jobId) => {
                        try {
                            const response = await this.readSandboxJobDetails(this.deployment.sandbox, jobId);
                            return {
                                jobId: jobId,
                                jobDetails: response?.data || null,
                                error: null
                            };
                        } catch (error) {
                            return {
                                jobId: jobId,
                                jobDetails: null,
                                error: error.response?.data?.error || error.message
                            };
                        }
                    })
                );
                this.jobDetails = JSON.parse(JSON.stringify(details));
            } catch (error) {
                console.error('Error fetching pipeline details:', error);
            } finally {
                this.loading = false;
                this.getPromotionStatusTrigger = !this.getPromotionStatusTrigger; // to trigger promotion status inspection
            }
        },
        async readSandboxJobDetails(sandboxName, jobName) {
            return axios.get(this.$store.state.lakeviewUrl + `/v1/cids/${this.$store.state.currentClient.cid}/sandboxes/${sandboxName}/jobs/${jobName}`, {
                headers: {
                    Authorization: `Bearer ${this.$store.state.accessToken}`,
                },
            })
        },
        closeClick() {
            this.$router.push({
                name: "Job Stack Deployments List",
                params: {
                    sandboxId: `${this.$route.params.sandboxId}`,
                },
            });
        },
        async getLatestExecutionId() {
            if (!this.pipelineJob?.jobId || !this.deployment?.sandbox) {
                console.log('No pipeline job or sandbox found..');
                return;
            }
            let executionId;
            await axios.get(`${this.$store.state.lakeviewUrl}/v1/cids/${this.$store.state.currentClient.cid}/sandboxes/${this.deployment.sandbox}/jobs/${this.pipelineJob.jobId}/executions?limit=1`, {
                headers: {
                    Authorization: `Bearer ${this.$store.state.accessToken}`,
                },
            }).then((response) => {
                if (response?.data?.length > 0 && response.data[0]?.execution_id) {
                    executionId = response.data[0].execution_id;
                }
            }).catch((error) => {
                console.error('Error fetching latest running execution id: ', error);
            });
            return executionId || "";
        },
        async trackPipelineExecutionStatus(executionId) {
            if (!executionId) {
                console.error('No running execution id found to track pipeline execution status...');
                return;
            }

            this.pipelineExecutionDetails = {};
            let details = {
                executionDetails: {},
            };
            const jobName = this.pipelineJob?.jobDetails?.name;
            const sandboxName = this.deployment?.sandbox;
            const cid = this.$store.state.currentClient?.cid;

            // this loop is to wait till the execution starts running    
            let retryCount = 25;
            try {
                while (retryCount > 0) {
                    const response = await axios.get(
                        `${this.$store.state.lakeviewUrl}/v1/cids/${cid}/sandboxes/${sandboxName}/jobs/${jobName}/executions/${executionId}`,
                        {
                            headers: {
                                Authorization: `Bearer ${this.$store.state.accessToken}`,
                            },
                        }
                    );
                    if (response.data?.status != 'SUBMITTED') {
                        break;
                    }
                    await new Promise(resolve => setTimeout(resolve, 5000)); // wait for 5 seconds
                    retryCount--;
                }
            } catch (error) {
                console.error('Error fetching pipeline job execution status: ', error);
            }

            this.running = true;
            try {
                // infinite loop until the component is unmounted or the pipeline is not running
                while (!this.breakCheck) {
                    let error = null;
                    const response = await axios.get(
                        `${this.$store.state.lakeviewUrl}/v1/cids/${cid}/sandboxes/${sandboxName}/pipelines/${jobName}/executions/${executionId}`,
                        {
                            headers: {
                                Authorization: `Bearer ${this.$store.state.accessToken}`,
                            },
                        }
                    ).catch((error) => {
                        error = error.response?.data?.error || error.message;
                        console.error('Error fetching pipeline execution details: ', error);
                    });
                    if (error) break;

                    // parse the response
                    response.data?.tasks?.forEach(task => {
                        let path = task.full_path.split('/'); // eg, task.full_path will be "/in_sequence/0/collator-job-multi-executors"
                        details.executionDetails[path[path.length - 1]] = task;
                    });
                    details = { ...details, ...response.data };
                    this.pipelineExecutionDetails = JSON.parse(JSON.stringify(details));

                    // stop if pipeline is not running
                    if (response.data?.status != 'RUNNING') break;
                    await new Promise(resolve => setTimeout(resolve, 5000)); // wait for 5 seconds
                }
            } catch (error) {
                console.error('Error fetching pipeline execution status: ', error);
            } finally {
                this.running = false;
            }
        },
        async onRunAllClick() {
            if (!this.pipelineJob || !this.pipelineJob.jobDetails) {
                console.log('No pipeline job found..');
                return;
            }

            this.running = true;
            try {
                const cid = this.$store.state.currentClient?.cid;
                const sandboxName = this.deployment?.sandbox;
                const jobName = this.pipelineJob?.jobDetails?.name; // pipeline job name
                const response = await axios.post(
                    `${this.$store.state.lakeviewUrl}/v1/cids/${cid}/sandboxes/${sandboxName}/jobs/${jobName}/executions`, {},
                    {
                        headers: {
                            Authorization: `Bearer ${this.$store.state.accessToken}`,
                        },
                    }
                );

                this.$store.dispatch("addToast", {
                    message: "Pipeline execution started successfully.",
                    type: "success",
                });

                // fetch the job execution status till the pipeline job is running
                await this.trackPipelineExecutionStatus(response?.data?.execution_id);
            } catch (error) {
                console.error('Error executing pipeline job:', error);
                this.$store.dispatch("addToast", {
                    message: error.response?.data?.error || error.message || "Failed to execute pipeline. Please contact support.",
                    type: "error",
                });
            } finally {
                this.running = false;
            }
        },
        setRunAllButton(visibility) {
            this.showRunAllButton = visibility;
        },
        setEditButton(visibility) {
            this.showEditButton = visibility;
        },
        onEditClick() {
            this.editMode = true;
        },
        setEditMode(mode) {
            this.editMode = mode;
        },
        onSaveclick() {
            this.saveTrigger = !this.saveTrigger;
        },
        onSaveAndRunCLick() {
            this.saveAndRunTrigger = !this.saveAndRunTrigger;
        },
        onCancelClick() {
            this.editMode = false;
            this.jobDetails = JSON.parse(JSON.stringify(this.jobDetails)); // to reset edited data
        },
        showSaving(saving) {
            this.saving = saving;
        },
        onPromoteClick() {
            this.promoteJobsTrigger = !this.promoteJobsTrigger;
        },
        showPromoting(promoting) {
            this.promoting = promoting;
        },
        setPromoteButton(visibility) {
            this.showPromoteButton = visibility;
        },
        getPromotionStatus(promotionStatus) {
            this.promotionStatus = JSON.parse(JSON.stringify(promotionStatus));
        },
        getSaveAndRunStatus(saveAndRunStatus) {
            this.saveAndRunStatus = JSON.parse(JSON.stringify(saveAndRunStatus));
        },
        async triggerPipelineStatusCheck(executionId) {
            await this.trackPipelineExecutionStatus(executionId);
        },
    },
};
</script>

<style scoped>
.custom-btn-group {
    display: flex;
    align-items: center;
}

.btn {
    margin-right: 12px;
}
</style>
